export default {
  props: {
    delay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {},
  methods: {
    start() {
      this.show = true;
    }
  },
  created() {
    setTimeout(this.start, this.delay);
  }
};
